import PredmetiAPI from './predmeti.api';
import KontaktiAPI from './kontakti.api';
import GenericAPI from './generic.api';
class API {
    constructor() {
        this.Predmeti = PredmetiAPI;
        this.Kontakti = KontaktiAPI;
        this.Generic = GenericAPI;
    }
}

export default new API();